import { Component, OnInit, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PhoneNumberErrors, PhoneNumberDetails, PhoneNumberConfig } from './phone-number.model';
import { Country } from 'src/app/shared/models/lookup-data.model';

@Component({
  selector: 'online-app-phone-number',
  templateUrl: './phone-number.component.html',
  styleUrls: ['./phone-number.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => PhoneNumberComponent),
    multi: true
  }]
})
export class PhoneNumberComponent implements OnInit,  ControlValueAccessor {

  disabled = false;

  constructor() { }

  @Input() config: PhoneNumberConfig;
  @Input() errors: PhoneNumberErrors;
  @Input() data: PhoneNumberDetails;

  private _value: PhoneNumberDetails = {
    mobileCountryCode: undefined,
    mobilePhoneNumber: undefined,
    homeCountryCode: undefined,
    homePhoneNumber: undefined
  };

  private _onChange = (_: any) => {};
  private _onTouched = (_: any) => {};


  ngOnInit() {
    this.value = this.data;
  }

  countryCodeDescription(country: Country) {
    const selectedCountry = this.config.countries.find(c => c.Code === country.Code);

    if (selectedCountry && selectedCountry.Code.length > 0) {
      return `${selectedCountry.Description} (+${selectedCountry.PhoneCode})`;
    }

    return 'Please select';
  }


  set value(value: PhoneNumberDetails) {
    this._value = value;
    this._onChange(this._value);
  }

  get value() {
    return this._value;
  }

  writeValue(value: PhoneNumberDetails): void {
    if (value && value !== null) {
      this._value = value;
    }
  }
  registerOnChange(fn: (_: any) => void): void {
    this._onChange = fn;
  }
  registerOnTouched(fn: (_: any) => void): void {
    this._onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  mobileCountryCodeUpdate(event: any) {
    // additional check or process
    this._updateValue(event.target.value, 'mobileCountryCode');
    this.errors.mobileCountryCode = '';
  }

  mobilePhoneNumberUpdate(event: any) {
    // additional check or process
    this._updateValue(event.target.value, 'mobilePhoneNumber');

    if(((event.target.value.length >= 4) && (event.target.value.length <= 12))
    || ((event.target.value.length === 0)))
    {
      this.errors.mobilePhoneNumber = '';
    }
    else
    {
      this.errors.mobilePhoneNumber = 'The length must be between 4 and 12';
    }
  }

  mobilePhoneNumberOnBlur(event: any) {
    if(((event.target.value.length >= 4) && (event.target.value.length <= 12))
    || ((event.target.value.length === 0)))
    {
      this.errors.mobilePhoneNumber = '';
    }
    else
    {
      this.errors.mobilePhoneNumber = 'The length must be between 4 and 12';
    }
  }

  homeCountryCodeUpdate(event: any) {
    // additional check or process
    this._updateValue(event.target.value, 'homeCountryCode');
    this.errors.homeCountryCode = '';
  }

  homePhoneNumberUpdate(event: any) {
    // additional check or process
    this._updateValue(event.target.value, 'homePhoneNumber');

    if(((event.target.value.length >= 4) && (event.target.value.length <= 12))
    || (event.target.value.length === 0) )
    {
      this.errors.homePhoneNumber = '';
    }
    else
    {
      this.errors.homePhoneNumber = 'The length must be between 4 and 12';
    }
  }

  homePhoneNumberOnBlur(event: any) {
    if(((event.target.value.length >= 4) && (event.target.value.length <= 12))
    || (event.target.value.length === 0) )
    {
      this.errors.homePhoneNumber = '';
    }
    else
    {
      this.errors.homePhoneNumber = 'The length must be between 4 and 12';
    }
  }


  private _updateValue(value: string, field: string) {
    const newValue = this._value;
    newValue[field] = value;
    this.value = newValue;
  }

}
